var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-field"},[_c('div',{staticClass:"field-label"},[_vm._v(" Скан копия ")]),_c('dashboard',{attrs:{"uppy":_vm.uppy,"plugins":['ImageEditor'],"props":_vm.dashboardOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }